module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-2-6147ab59bb111f45a641869baedd7893.png";